/**
 * Pre-compiled es messages for DatePicker
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  "Time.enterTime": `Indicar tiempo`,
  "Time.enterTimeHour": `Indicar tiempo (hora)`,
  "Time.enterTimeHourMinute": `Indicar tiempo (hora y minuto)`,
  "Time.enterTimeHourMinuteSecond": `Indicar tiempo (hora, minuto y segundo)`,
  "Time.startTime": `Iniciar tiempo`,
  clearInput: `Eliminar valor de entrada`,
};
